// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"MenuIcon__menuIcon___3PYzS","active":"MenuIcon__active___1C0AG","tpb":"MenuIcon__tpb___332Ix"};